var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAirlineSeatReclineExtra = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2767_562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.35 5.63999C4.45 4.99999 4.23 3.75999 4.86 2.84999C5.49 1.94999 6.74 1.72999 7.65 2.35999C8.55 2.99999 8.77 4.23999 8.14 5.14999C7.5 6.04999 6.26 6.26999 5.35 5.63999ZM16 19H6.5L4 6.99999H2L4.85 21H16V19ZM16.23 15H11.35L10.32 10.9C11.9 11.79 13.6 12.44 15.47 12.12V9.98999C13.84 10.3 12.03 9.71999 10.78 8.73999L9.14 7.46999C8.91 7.28999 8.65 7.16999 8.38 7.08999C8.06 6.99999 7.72 6.96999 7.39 7.02999H7.37C6.14 7.24999 5.32 8.41999 5.53 9.63999L7.44 18H16.68L20.5 21L22 19.5L16.23 15Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2767_562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAirlineSeatReclineExtra, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/airline_seat_recline_extra.066d767a.svg";
export { ForwardRef as ReactComponent };